import UserMenuContent from './UserMenuContent';

const UserMenu = ({ isAuthenticated, sandboxSignInUrl }) => {
  return (
    <div className="user-menu-container" id="user-menu">
      <UserMenuContent isAuthenticated={isAuthenticated} sandboxSignInUrl={sandboxSignInUrl} />
    </div>
  );
};

export default UserMenu;
